import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { getImage, GetImageAction, GetImageSuccess } from 'src/actions/image/get/GetImage.actions';
import * as getImageTypes from 'src/actions/image/get/Types';
import FileImage from './FileImage.component';

interface DispatchProps {
  getImage(imageName: string): Promise<GetImageAction>;
}

interface State {
  image?: File;
}

interface Props extends DispatchProps {
  alt?: string;
  url?: string | File;
  style?: {};
  className?: string;
  defaultImagePath?: string;
}

class ImageContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public componentWillMount(): void {
    if (this.props.url && typeof this.props.url !== 'object') {
      this.props.getImage(this.props.url).then((response: GetImageSuccess) => {
        if (response.type === getImageTypes.GET_IMAGE_SUCCESS) {
          this.setState({ image: response.payload });
        }
      });
    }
  }

  public componentWillReceiveProps(newProps: Props): void {
    if (newProps.url !== this.props.url && newProps.url && typeof newProps.url !== 'object') {
      this.props.getImage(newProps.url).then((response: GetImageSuccess) => {
        if (response.type === getImageTypes.GET_IMAGE_SUCCESS) {
          this.setState({ image: response.payload });
        }
      });
    }
  }

  public render(): React.ReactNode {
      return (
        <FileImage
          alt={this.props.alt || ''}
          image={!this.props.url ? undefined : (typeof this.props.url === 'object' ? this.props.url : this.state.image)}
          defaultImagePath={this.props.defaultImagePath || '/img/pic.png'}
          style={this.props.style}
          className={this.props.className}
        />
      );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getImage: (imageName: string): Promise<GetImageAction> => (
      dispatch(getImage(imageName))
    )
  });

export default connect(null, mapDispatchToProps)(ImageContainer);


// WEBPACK FOOTER //
// ./src/modules/commons/images/Image.container.tsx